import { ModalController } from "./Controller/ModalController.js";
import { AlertModalController } from "./Controller/AlertModalController.js";
import { ConfirmModalController } from "./Controller/ConfirmModalController.js";
import { LoadingModalController } from "./Controller/LoadingModalController";
import { OtpModalController } from "./Controller/OtpModalController.js";
import { ListGiftModalController } from "./Controller/ListGiftModalController.js";
import { ScrollBodyModalController } from "./Controller/ScrollBodyModalController.js";

export default function ModalFactory() {
    this.modalController = new ModalController();
    this.alertModal = null;
    this.confirmModal = null;
    this.loadingModal = null;
    this.otpModal = null;
    this.listGiftModal = null;
    this.scrollBodyModal = null;

    this.getModalController = function () {
        return this.modalController;
    };

    this.getAlertModal = function () {
        this.alertModal = new AlertModalController();
        this.modalController.setAlertModal(this.alertModal);
        return this.alertModal;
    };

    this.getConfirmModal = function () {
        this.confirmModal = new ConfirmModalController();
        this.modalController.setConfirmModal(this.confirmModal);
        return this.confirmModal;
    };

    this.getLoadingModal = function () {
        this.loadingModal = new LoadingModalController();
        this.modalController.setLoadingModal(this.loadingModal);
        return this.loadingModal;
    };

    this.getOtpModalController = function () {
        this.otpModal = new OtpModalController();
        this.modalController.setOtpModal(this.otpModal);
        return this.otpModal;
    };

    this.getListGiftModalController = function () {
        this.listGiftModal = new ListGiftModalController();
        this.modalController.setListGiftModal(this.listGiftModal);
        return this.listGiftModal;
    };


    this.getScrollBodyController = function () {
        this.scrollBodyModal = new ScrollBodyModalController();
        this.modalController.setScrollBodyModal(this.scrollBodyModal);
        return this.scrollBodyModal;
    };
}
